<div class="wrapper" *ngIf="text">
    <div innerHTML="{{ displayedText }}"></div>
    <button *ngIf="shouldDisplayReadMore" (click)="transformText()">Read More +</button>
    <button *ngIf="!shouldDisplayReadMore" (click)="transformText()">Read Less -</button>
</div>
